<template>
  <header class="header" :style="headerStyle">
    <img :src="siteLogoUrl" class="header__logo" :id="$idMapper.header.logo" alt="" v-show="!pageTitle" />
    <div class="header__title" v-show="pageTitle">{{ $t(pageTitle) }}</div>

    <template v-if="siteIsActive">
      <div
        class="header__link header__link--home"
        :id="$idMapper.header.link.home"
        @click="changeRoute('Home')"
        v-if="$route.meta['header-back-icon'] != true"
      ></div>
      <a class="header__link header__link--back" href="javascript:;" @click="$router.go(-1)" v-else></a>

      <component :is="AppHeaderMenu" />
    </template>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppHeader',
  props: {
    logo: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    ...mapGetters([
      'pageTitle',
      'siteSetting',
      'siteLogoUrl',
      'siteIsActive',
      'siteID',
      'userIsLoggedIn',
      'siteMainDomain',
    ]),
    AppHeaderMenu() {
      if (this.siteSetting.components.header.AppHeaderMenu) {
        return () => import(`@/${this.siteSetting.components.header.AppHeaderMenu}`);
      }
      return '';
    },
    imgHeader() {
      try {
        return require(`@/assets/common/header/headerBg--${this.siteMainDomain}.png`);
      } catch {
        return require(`@/assets/common/header/headerBg.png`);
        // return require(`@/assets/common/header/headerBg--THRY1688M_net.jpg`);
        // return require(`@/assets/common/header/headerBg--THRY1688M_net.png`);
      }
    },
    headerStyle() {
      return { background: `url(${this.imgHeader}) no-repeat top center` };
    },
  },
  methods: {
    changeRoute(route) {
      if (route !== this.$route.name) {
        this.$router.push({ name: route });
      }
    },
  },
};
</script>
